/**
 * Email validation utilities
 */

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Normalize email input - converts string or array to clean array
 * @param {string|string[]} value - Email(s) to normalize
 * @returns {string[]} Array of trimmed email addresses
 */
export const normalizeEmails = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value.map((e) => String(e).trim()).filter(Boolean);
  return String(value).split(/[,;]+/).map((e) => e.trim()).filter(Boolean);
};

/**
 * Validate a single email
 * @param {string} email - Email to validate
 * @returns {boolean} True if email is valid
 */
export const isValidEmail = (email) => EMAIL_REGEX.test(email);

/**
 * Validate a list of emails
 * @param {string|string[]} emails - Email(s) to validate
 * @returns {boolean} True if all emails are valid and at least one exists
 */
export const isValidEmailList = (emails) => {
  const list = normalizeEmails(emails);
  if (list.length === 0) return false;
  return list.every((e) => EMAIL_REGEX.test(e));
};

/**
 * Validate and separate emails into valid and invalid
 * @param {string|string[]} emails - Email(s) to validate
 * @returns {{valid: string[], invalid: string[]}} Object with valid and invalid emails
 */
export const validateEmails = (emails) => {
  const list = normalizeEmails(emails);
  return {
    valid: list.filter((e) => isValidEmail(e)),
    invalid: list.filter((e) => !isValidEmail(e)),
  };
};

export default {
  normalizeEmails,
  isValidEmail,
  isValidEmailList,
  validateEmails,
};
